import { Pipe, PipeTransform } from '@angular/core';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
dayjs.extend(relativeTime);

@Pipe({
    standalone: true,
    name: 'relativeDate'
})
export class RelativeDatePipe implements PipeTransform {
    transform(date: Date): string {
        return dayjs().to(date);
    }
}
